<div class="panel-box" [ngBusy]="{ busy: loading, message: ('common.pleaseWait' | translate)}">
  <div class="pb-header d-md-block d-none"
       [translate]="'profile.orderHistory.header'">Order history
  </div>
  <div
    *ngIf="loaded"
    class="pb-content p-0">
    <table class="pb-table-lg">
      <thead>
      <tr>
        <th class="font-xxs" [translate]="'common.order.number'">Order number</th>
        <th class="font-xxs" [translate]="'profile.orderHistory.orderDate'">Order date</th>
        <th class="font-xxs" [translate]="'common.delivery.deliveryDate'">Delivery date</th>
        <th class="font-xxs" [translate]="'profile.orderHistory.bakeryName'">Name of bakery</th>
        <th class="font-xxs text-end" [translate]="'common.price'">Price</th>
        <th class="font-xxs" [translate]="'profile.orderHistory.receipt'">Receipt</th>
      </tr>
      </thead>
      <tbody class="font-sm">
      <tr *ngFor="let order of orders">
        <td>{{order.number}}</td>
        <td>{{getDateFormat(order.createdDate)}}</td>
        <td>{{getDateFormat(order?.bakeryOrders[0]?.deliveryOrder.deliveryDate)}}</td>
        <td>{{order?.bakeryOrders[0]?.bakery?.name}}</td>
        <td class="text-end">{{order.price | currencyFormat: getCurrency(order)}}</td>
        <td>
          <a *ngIf="!isOrderFromOldStore(order) && !isOrderFromAdminPanel(order)"
             class="receipt-url"
             [href]="'#'"
             (click)="$event.preventDefault(); getOrderReceiptUrl(order)">PDF<i class="icon-download"></i></a>
        </td>
      </tr>
      </tbody>
    </table>
    <table class="pb-table-xs font-sm mt-xs-max-2">
      <tbody *ngFor="let order of orders; let i=index" class="position-relative">
      <tr [ngBusy]="{busy: loadersMap[order.bakeryOrders[0].id], message: ('common.pleaseWait' | translate)}">
        <td class="fw-bold pl-xs-max-0"
            [class.bt-md-max-0]="!i"
            [translate]="'common.order.number'">Order number
        </td>
        <td [class.bt-md-max-0]="!i">{{order.number}}</td>
        <td class="text-end pr-xs-max-0" [class.bt-md-max-0]="!i">
          {{order.price | currencyFormat: getCurrency(order)}}
        </td>
      </tr>

      <tr>
        <td class="fw-bold pl-xs-max-0" [translate]="'profile.orderHistory.orderDate'">Order date</td>
        <td colspan="2">{{getDateFormat(order.createdDate)}}</td>
      </tr>

      <tr>
        <td class="fw-bold pl-xs-max-0" [translate]="'common.delivery.deliveryDate'">Delivery date</td>
        <td colspan="2">{{getDateFormat(order?.bakeryOrders[0]?.deliveryOrder.deliveryDate)}}</td>
      </tr>

      <tr>
        <td class="fw-bold pl-xs-max-0" [translate]="'profile.orderHistory.bakeryName'">Name of bakery</td>
        <td>{{order?.bakeryOrders[0]?.bakery?.name}}</td>
        <td class="text-end pr-xs-max-0">
          <a *ngIf="!isOrderFromOldStore(order) && !isOrderFromAdminPanel(order)"
             class="receipt-url justify-content-end"
             [href]="'#'"
             (click)="$event.preventDefault(); $event.stopPropagation(); getOrderReceiptUrl(order)">PDF<i
            class="icon-download"></i></a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="loaded && orders?.length === 0"
       class="pb-content text-center p-3"
       [translate]="'profile.orderHistory.noOrdersYet'">
    No orders yet...
  </div>
</div>
